<template>
    <div class="container" style="float: none;">
        <div class="form-group">
            <label class="col-md-2 control-label text-label">{{srMediaType.name}}</label>
            <div class="col-md-10">
                <v-client-table :data="scannedReportMediaList" :columns="srGridSpec.columns" :options="srGridSpec.options">
                    <template slot="download" slot-scope="props">
                        <div style="text-align: center">
                            <a  class="fa fa-cloud-download" style="font-size: 18px;" v-on:click="mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.mediaSubtype, props.row.parentId, props.row.filename)"></a>
                        </div>
                    </template>
                    <template slot="remove" slot-scope="props" v-if="isShpo">
                        <div style="text-align: center">
                            <a class="fa fa-ban" style="font-size: 18px;" v-on:click="mediaRemove(props.row.mediaId)"></a>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
        <div v-for="mediaType in docMediaTypes" class="form-group" :value="mediaType.mediaTypeId" :key="mediaType.mediaTypeId">
            <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
            <div class="col-md-10">
                <v-client-table :data="gridSpec.tableData.filter(x => { return x.mediaTypeId === mediaType.mediaTypeId})" :columns="gridSpec.columns" :options="gridSpec.options">
                    <template slot="download" slot-scope="props">
                        <div style="text-align: center">
                            <a  class="fa fa-cloud-download" style="font-size: 18px;" v-on:click="mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.mediaSubtype, props.row.parentId, props.row.filename)"></a>
                        </div>
                    </template>
                    <template slot="recording" slot-scope="props">
                        <div style="text-align: center" v-if="props.row.crrId !== prodCrrId">
                            <a v-on:click="viewRecording(props.row.crrId)">{{ props.row.crrId }}</a>
                        </div>
                    </template>
                    <template slot="remove" slot-scope="props" v-if="isShpo && props.row.crrId === prodCrrId">
                        <div style="text-align: center">
                            <a class="fa fa-ban" style="font-size: 18px;" v-on:click="mediaRemove(props.row.mediaId)"></a>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
        <div class="form-group" v-if="isShpo">
            <label class="col-md-2">Add File</label>
            <div class="col-md-10">
                <fieldset>
                    <form v-on:submit.prevent class="form" id="mediaForm" data-vv-scope="mediaFile">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaTypeId') }">
                                    <label>Type</label>
                                    <select name="mediaTypeId" class="form-control" v-model="selectedMediaTypeId" v-validate="'required'" data-vv-validate-on="none">
                                        <option v-bind:value="srMediaType.mediaTypeId">
                                            Scanned Document
                                        </option>
                                        <option v-bind:value="docMediaTypes[0].mediaTypeId">
                                            Image
                                        </option>
                                        <option v-bind:value="docMediaTypes[1].mediaTypeId">
                                            Laboratory Result
                                        </option>
                                    </select>
                                    <div><span v-show="errors.has('mediaFile.mediaTypeId')" class="has-error">File type is required</span></div>
                                </div>
                            </div>
                            <div v-if="selectedMediaTypeId === 7" class="col-md-2">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaSubtypeId') }">
                                    <label>Subtype</label>
                                    <select name="mediaSubtypeId" class="form-control" v-model="mediaSubtypeId" v-validate="'required'" data-vv-validate-on="none">
                                        <option disabled value=''>Select a value</option>
                                        <option v-show="selectedMediaTypeId === 7" v-for="subtypes in labResultsSubtypes" :value="subtypes.mediaSubtypeId" :key="subtypes.mediaSubtypeId">
                                            {{subtypes.name}}
                                        </option>
                                    </select>
                                    <div><span v-show="errors.has('mediaFile.mediaSubtypeId')" class="has-error">Subtype is required</span></div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                    <label>File</label><br>
                                    <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'" data-vv-validate-on="none">
                                    <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.comment') }">
                                    <label>Comment</label>
                                    <input name="comment" type="text" class="form-control" v-model="comment" v-validate="'required'" data-vv-validate-on="none">
                                    <div><span v-show="errors.has('mediaFile.comment')" class="has-error">Comment is required</span></div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-primary col-md-1" v-on:click="addFile">Upload</button>
                    </form>
                </fieldset>
            </div>
        </div>
        <div>
            <label class="col-md-2 control-label text-label"></label>
        </div>
    </div>
</template>

<script>
import mediaService from '../../services/mediaService'
import loggingService from '../../services/util/loggingService'
import rockArtService from '../../services/siteForm/rockArtService'
import historicBuildingService from '../../services/siteForm/historicBuildingService'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'

export default {
    name: 'siteFormDocuments',
    data: function () {
        return {
            isDebug: false,
            culturalResourceId: this.$route.params.culturalResourceId,
            docMediaTypes: [
                {name: 'Images', mediaTypeId: mediaService.mediaType.CulturalResourceImages},
                {name: 'Laboratory Results', mediaTypeId: mediaService.mediaType.CulturalResourceLabResults}
            ],
            imageSubtypes: [
                {name: null, mediaSubtypeId: null},
                {name: 'Site Overview', mediaSubtypeId: mediaService.mediaSubtype.SiteOverviewImage},
                {name: 'Artifact', mediaSubtypeId: mediaService.mediaSubtype.ArtifactImage},
                {name: 'Feature', mediaSubtypeId: mediaService.mediaSubtype.FeatureImage},
                {name: 'Rock Art', mediaSubtypeId: mediaService.mediaSubtype.RockArtImage},
                {name: 'Building', mediaSubtypeId: mediaService.mediaSubtype.BuildingImage},
                {name: 'Other', mediaSubtypeId: mediaService.mediaSubtype.OtherImage}
            ],
            labResultsSubtypes: [
                {name: 'Radiocarbon', mediaSubtypeId: mediaService.mediaSubtype.RadioCarbon},
                {name: 'Material Sourcing', mediaSubtypeId: mediaService.mediaSubtype.MaterialSourcing},
                {name: 'Other Lab Results', mediaSubtypeId: mediaService.mediaSubtype.OtherLabResults}
            ],
            mediaList: [],
            gridSpec: {
                tableData: [],
                columns: ['download', 'recording', 'subtypeDescription', 'filename', 'comment', 'createdDate', 'remove'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        subtypeDescription: 'File Type',
                        filename: 'File Name',
                        comment: 'Comment',
                        createdDate: 'Upload Date'
                    },
                    dateColumns: ['createdDate'],
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            srMediaType: {
                name: 'Scanned Documents',
                mediaTypeId: mediaService.mediaType.CulturalResourceProdScannedReport
            },
            srGridSpec: {
                tableData: [],
                columns: ['download', 'filename', 'comment', 'createdDate', 'remove'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        filename: 'File Name',
                        comment: 'Comment',
                        createdDate: 'Upload Date'
                    },
                    dateColumns: ['createdDate'],
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            scannedReportMediaList: [],
            mediaTypeId: mediaService.mediaType.CulturalResourceProdScannedReport,
            selectedMediaTypeId: null,
            mediaSubtypeId: null,
            comment: ''
        }
    },
    props: {
        loadOnMount: { default: true },
        prodCrrId: { default: null },
        isShpo: { default: false }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                result.data.forEach(x => {
                    x.crrId = x.parentId
                    if (x.mediaSubtypeId) {
                        var match = this.imageSubtypes.find(y => { return y.mediaSubtypeId === x.mediaSubtypeId })
                        if (match) x.imageSubtype = match.name
                    }
                })
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadRockArtBuildingMedia (mediaTypeId, mediaSubtypeId, parentId, crrId) {
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                result.data.forEach(x => {
                    x.crrId = x.crrId
                })
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadImages (crrId) {
            var promises = [this.loadRockArtImages(crrId), this.loadBuildingImages(crrId)]
            this.imageSubtypes.filter(x => {
                return x.mediaSubtypeId !== mediaService.mediaSubtype.BuildingImage &&
                x.mediaSubtypeId !== mediaService.mediaSubtype.RockArtImage
            }).forEach(x => {
                promises.push(this.loadMedia(mediaService.mediaType.CulturalResourceImages, x.mediaSubtypeId, crrId))
            })
            return Promise.all(promises).then(result => { return result })
        },
        loadRockArtImages (crrId) {
            return rockArtService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                var promises = []
                result.data.forEach(rockArt => {
                    promises.push(this.loadRockArtBuildingMedia(mediaService.mediaType.CulturalResourceImages, mediaService.mediaSubtype.RockArtImage, rockArt.rockArtPanelId, crrId))
                })
                Promise.all(promises).then(result => {
                    return result
                })
            })
        },
        loadBuildingImages (crrId) {
            return historicBuildingService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                var promises = []
                result.data.forEach(building => {
                    promises.push(this.loadRockArtBuildingMedia(mediaService.mediaType.CulturalResourceImages, mediaService.mediaSubtype.BuildingImage, building.historicBuildingFormId, crrId))
                })
                Promise.all(promises).then(result => {
                    return result
                })
            })
        },
        loadLabResults (crrId) {
            var promises = []
            this.labResultsSubtypes.forEach(x => {
                promises.push(this.loadMedia(mediaService.mediaType.CulturalResourceLabResults, x.mediaSubtypeId, crrId))
            })
            return Promise.all(promises).then(result => { return result })
        },
        loadScannedReports () {
            return this.loadMedia(mediaService.mediaType.CulturalResourceProdScannedReport, null, this.prodCrrId).then(result => {
                this.scannedReportMediaList = result.data
                return result
            })
        },
        loadData () {
            this.gridSpec.tableData = []
            this.mediaList = []
            //get the list of recordings for this site
            culturalResourceRecordingService.getRecordingList(this.$http, this.culturalResourceId).then(result => {
                var promises = []
                promises.push(this.loadImages(this.prodCrrId))
                promises.push(this.loadLabResults(this.prodCrrId))
                result.data.forEach(site => {
                    promises.push([
                        this.loadImages(site.culturalResourceRecordingId),
                        this.loadLabResults(site.culturalResourceRecordingId),
                        this.loadMedia(mediaService.mediaType.CulturalResourceLabResults, null, site.culturalResourceRecordingId)
                    ])
                })
                Promise.all(promises).then(result => {
                    var mediaImageList = this.mediaList.filter(x => {
                        return x.mediaTypeId === mediaService.mediaType.CulturalResourceImages
                    })
                    mediaImageList.forEach(x => {
                        x.subtypeDescription = (this.imageSubtypes.find(y => { return y.mediaSubtypeId === x.mediaSubtypeId }) || {name: ''}).name
                    })
                    var mediaLabResultList = this.mediaList.filter(x => {
                        return x.mediaTypeId === mediaService.mediaType.CulturalResourceLabResults
                    })
                    mediaLabResultList.forEach(x => {
                        x.subtypeDescription = (this.labResultsSubtypes.find(y => { return y.mediaSubtypeId === x.mediaSubtypeId }) || {name: ''}).name
                    })
                    this.gridSpec.tableData = mediaImageList.concat(mediaLabResultList)
                })
                this.log('After load, media list count: ' + this.mediaList.length)
                this.loadScannedReports()
            })
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        },
        viewRecording (id) {
            this.$router.push('/CulturalResourceRecording/' + id)
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Adding file. Type: ${this.selectedMediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                    mediaService.putFile(this.$http, this.selectedMediaTypeId, this.mediaSubtypeId, this.prodCrrId, file, this.comment).then(result => {
                        this.clearFileInput()
                        this.loadData()
                        this.errors.clear()
                    })
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        clearFileInput () {
            document.forms['mediaForm'].reset()
            this.mediaTypeId = ''
            this.mediaSubtypeId = ''
            this.comment = ''
        },
        mediaRemove (mediaId) {
            if (confirm('Are you sure you want to delete this file/document?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadData()
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteDocuments.vue?179b9fe4